// tslint:disable
const GLOBAL = {
    QUOTA: 'Cuota',
    ENTRY: 'Entrada',
    TERM: 'Plazo',
    OFFER: 'Ofertas',
    WHATSAPP: 'Whatsapp',
    SAVE: 'Guardar',
    CLIENT: 'Cliente',
    MONTHS: 'meses',
    CONFIRM: 'Confirmar',
    CALL: 'Llamar',
    EMAIL: 'correo electrónico',
    PASSWORD: 'contraseña',
    DELETE: 'borrar',
    TAB_COMPLETE: 'COMPLETAS',
    TAB_IN_PROCESS: 'EN PROCESO',
    TAB_INCOMPLETE: 'INCOMPLETAS',
    TAB_PENDING: 'PENDIENTES',
    TAB_STATUS: 'ESTADO',
    TAB_OBSERVATIONS: 'OBSERVACIONES',
    ORDER_BY: 'ORDENAR POR:',
    SEARCH: 'Buscar',
    ADD: 'Adicionar',
    BACK: 'Atrás',
    ACCEPT: 'Aceptar',
    DONT_SHOW_AGAIN: 'no volver a mostrar',
    SEND: 'Enviar',
    CONTINUE: 'Continuar',
    NAME_LASTNAME: 'Nombre y apellidos',
    APPLICANT_NAME: 'Nombre del solicitante',
    NAME: 'Nombres',
    LASTNAME: 'Apellidos',
    CELLPHONE: 'Teléfono celular',
    PHONE: 'Teléfono fijo',
    EDIT: 'EDITAR',
    CHANGE: 'Cambiar Cuenta',
    NO_RESULTS: 'No se encontraron resultados',
    CLOSE: 'Cerrar',
    UPDATE_AVAILABLE: 'Actualización disponible',
    UPDATE_MESSAGE: 'Existe una nueva versión para Motorfy, para continuar usando sus servicios actualiza a la nueva versión.',
    UPDATE_NOW: 'Actualizar ahora',
    SELECT: 'Selecciona',
    ENTER_POSTAL_CODE: 'Ingrese código postal',
    RETRY: 'Reintentar',
    LOADING: 'Cargando',
    SERVER_ERROR_MESSAGE: '<b>Existió un error en el servidor</b><br>Por favor inténtelo en unos momentos'
};

const LOGIN = {
    SIDE_TITLE: 'FINANCIAMIENTO EN LÍNEA',
    SIDE_DETAIL: 'La plataforma que te permite comprar el auto de tus sueños a crédito con las mejores condiciones del mercado.',
    SIDE_SN: 'Con el respaldo de',
    SIDE_TIMER_TITLE: 'Aprobación en horas',
    SIDE_TERM_TITLE: 'Hasta 48 meses plazo',
    SIDE_TAX_118_TITLE: 'Tasa desde 1.18%**',
    SIDE_CASHDOWN_TITLE: 'Desde 20% de enganche',
    SIDE_AVAL_TITLE: 'Sin aval',
    SIDE_ELEVEN_YEARS_TITLE: 'Vehículos hasta 11 años',
    SSO_LOADING: 'cargando..',
    SSO_AUTHENTICATING: 'autenticando..'
};

const LOAN_APPLICATION = {
    TITLE: 'Solicitudes de crédito',
    SUBTITLE: 'No tienes solicitudes $name, inicia una solicitud desde la calculadora de cuotas.',
    INIT_LOAN: 'Inicia una solicitud',
    LOAN_STATUS: 'Estado de la solicitud',
    LOAN_CONTINUE: 'Continuar Solicitud',
    SAVE_CONTACT: 'Guardar contacto',
    CALL_CLIENT: 'Llamar al solicitante',
    CALL_CONCIERGE: 'Llamar al asesor ',
    TAB_MESSAGE_EMPTY: 'No tienes mensajes en esta solicitud.',
    TAB_MESSAGE: 'Mensajes',
    TAB_STATUS: 'Estatus',
    TAB_DETAIL: 'Detalles',
    TAB_MESSAGE_ID: 'messages',
    TAB_STATUS_ID: 'statuses',
    TAB_DETAIL_ID: 'details',
    FOLLOWING: 'Siguiente',
    FINISH: 'Finalizar',
    FIRST_NAME: 'Primer nombre',
    LAST_NAME: 'Apellido paterno',
    BIRTH_DATE: 'Fecha de nacimiento',
    CIVIL_STATUS: 'Estado civil',
    AMOUNT_DEPENDENTS: 'Cant. de dependientes económicos',
    CURP: 'CURP',
    ROLE_HOME: 'Rol en el hogar',
    REGIME: 'Régimen',
    STUDIES: 'Estudios',
    HOME_TYPE: 'Tipo de domicilio',
    HOME_ROOT: 'Arraigo domicilio',
    HOME_ROOT_YEAR: 'Arraigo domicilio año',
    CELL_PHONE: 'Celular',
    EMAIL: 'Correo Electrónico',
    DOC_NUMBER: 'Cédula de identidad',
    PARTNER_DOC_NUMBER: 'Cédula de identidad Cónyugue',
    EMPLOYMENT_TYPE: 'Tipo de relación laboral',
    TOTAL_INCOME_MONTHLY: 'Total de ingresos mensuales',
    REAL_STATE: 'Bienes raíces',
    VEHICLES: 'Vehículos',
    APPLICANT_DATA: 'Datos del solicitante',
    SPOUSE_APPLICANT_DATA: 'Datos del Cónyugue',
    ECONOMIC_INFORMATION: 'Información económica',
    FINGER_CLIENT: 'Firma del cliente',
    APPLICANT_AVALUO: 'Avalúo de bienes personales',
    TITLE_SENT: 'Solicitud enviada',
    TITLE_THANKS_COMPLETE: 'Gracias por completar tu solicitud de crédito',
    TITLE_LOAN_COMPLETED: 'Solicitud completa',
    SUCCESS_TEXT: 'En un momento nos comunicaremos contigo',
    SUCCESS_TEXT_CONTACT_ASSISTANT: 'en unos momentos nuestros asistentes se cominicarán contigo',
    SUCCESS_TEXT_SCHEDULE_INFO: 'Nuestro horario de atención es de lunes a viernes de 9 a 19 horas y los sábados de 9 a 13 horas',
    TITLE_EQUIFAX: 'Solicitud rechazada',
    START_LOAN: 'Nueva solicitud',
    GOT_TO_SUMMARY: 'Ver Resumen',
    SUMMARY: 'Resumen',
    CHECK_EQUIFAX : 'Declaro haber leido integramente los términos y condiciones del servicio Motorfy contenidos dentro del portal web solicitudes.motorfy.com, los cuales acepto en su totalidad.',
    FINGER_SIGN: 'Utiliza tu dedo para firmar en esta zona',
    EQUIFAX_AUTH: ' autorizo a PatioTuerca.com (Avisoriaweb) y/o a las instituciones financieras y no financieras con las que trabaja a consultar mi historial crediticio',
    ECONOMIC_INFO_DETAIL: 'Incluye un promedio del total de ingresos mensuales  de tu núcleo familiar, entre salarios, comisiones, bonos, así como el avalúo de tus activos, esto ayudará a evaluar la capacidad de endeudamiento.',
    MONTHLY_QUOTA: 'cuota mensual',
    FILTER_TITLE: 'Filtrar',
    FILTER_STATUS_LABEL: 'Estatus',
    FILTER_BUTTON_CLEAN_LABEL: 'Restablecer',
    FILTER_BUTTON_LABEL: 'Ver Resultados'
};

const LOAN_APPLICATION_MX = {
    SHARE_BUTTON: 'Compartir Cotización',
    APPLICANT_DATA_MESSAGE: 'Completa este formulario con tus datos reales, no te tomará más de 10 minutos, ten en cuenta que de esto dependerá la aprobación de tu crédito.',
    FIRST_NAME: 'Primer nombre',
    REFERENCES_NAME: 'Nombre',
    SECOND_NAME: 'Segundo nombre',
    LAST_NAME: 'Apellido paterno',
    SECOND_LAST_NAME: 'Apellido materno',
    BIRTH_DATE: 'Fecha de nacimiento',
    RFC_WITH_HOMOKEY: 'RFC CON HOMOCLAVE',
    RFC_NUMBER: 'RFC',
    CELL_PHONE: 'Celular',
    EMAIL: 'Correo Electrónico',
    GENDER: 'Género',
    CIVIL_STATUS: 'Estado Civil',
    STUDIES: 'Nivel de Estudios',
    ECONOMIC_DEPENDENTS: 'Dependientes Económicos',
    ALREADY_HAS_VEHICLES: 'Cuenta con vehículo',
    NIP: 'Código de verificación',
    NIP_IDENTITY: 'Código de validación',
    SELECT_INSURANCE_TEXT: 'Selecciona el seguro al que el solicitante desea aplicar.',
    SELECT_BUREAU_TEXT: 'Selecciona las opciones que se ajusten al solicitante.',
    INCLUDE_INSURANCE: 'Incluir seguro vehicular en el crédito',
    COMPLETE_NAME: 'Nombre y Apellido',
    CREDIT_CARD_LAST_NUMBERS: '4 últimos dígitos de la tarjeta',
    SCHEDULE_CONTACT: 'Tipo de Teléfono',
    CONTACT_TIME: 'Horario de Contacto',
    CONTACT_NUMBER: 'Número de Contacto',
    PHONE_EXTENTION: 'Extensión',
    REFERENCE_TITLE: 'Referencia',
    REFERENCE_DESCRIPTION: 'Agrega 3 referencias, esto nos ayudará a evaluar tu historial crediticio.',
    MORE_INFO: 'más info',
    BUREAU: 'Buró',
    NEXT: 'Siguiente',
    UPDATE: 'Actualizar',
    CALL_CLIENT: 'Llamar al Solicitante',
    ASK_NIP: 'Solicitar Código',
    VALIDATE_NIP: 'Validar código',
    SKIP_IDENTITY_VALIDATION: 'Continuar sin validar',
    IDENTITY_VALIDATION_MSG: 'Asegúrate de ingresar tus datos correctamente. Enviaremos un código a tu correo y celular para validar tu identidad e historial de crédito.',
    NIP_VALIDATION_LEGAL_MSG: 'Al ingresar el código aceptas el uso de tus datos personales y autorizas que consultemos tu historial de crédito.',
    NIP_VALIDATION_LEGAL_SCOTIA_MSG: 'Al ingresar el código aceptas la solicitud de tu reporte de crédito así como nuestros términos para la autorización de la consulta de Buró',
    BUREAU_VALIDATION_LEGAL_MSG: 'Al ingresar el código autorizas que consultemos tu historial de crédito.',
    SKIP_NIP: 'Omitir verificación',
    RESEND_NIP_IN: 'reenviar código en',
    RESEND_NIP: '¿No recibiste el Código? reenviar',
    EDIT_FOR_NIP: 'Editar contacto',
    BUREAU_TITLE_SORRY: 'Lo sentimos',
    BUREAU_SORRY_MESSAGE: 'Tu solicitud de crédito no se ajusta a los requisitos de la financiera, debido a tu historial crediticio.',
    BUREAU_SORRY_INVITATION_LONG_TEXT: 'Te invitamos a que lo intentes en un futuro cercano.',
    BUREAU_SORRY_INVITATION: 'Inténtalo en un futuro cercano',
    NIP_QUERY_ERROR: 'Error de consulta',
    NIP_QUERY_MESSAGE: 'Estimado $name, ingresa el código de validación que enviamos al correo $email y al $phone.',
    NIP_QUERY_ERROR_MESSAGE: 'No hemos podido consultar tu historial crediticio.',
    NIP_QUERY_ERROR_INPUT_DATA: 'Por favor ingresa los siguientes datos para que podamos realizar la consulta.',
    NIP_TITLE_ALREADY_VALIDATED: 'Validación Exitosa',
    NIP_TITLE_ALREADY_VALIDATED_SUCCESS: 'Felicitaciones',
    NIP_CONGRATULATIONS_SUCCESS_MSG: 'Tu crédito ha sido pre aprobado. Estas muy cerca de conseguirlo, da clic en "continuar solicitud" y completa los datos restantes',
    NIP_CONGRATULATIONS_ALREADY_VALIDATED: 'Felicidades $name, estás un paso más cerca de tener tu $desiredVehicle.',
    NIP_MESSAGE_ALREADY_VALIDATED: 'Consultamos tu historial crediticio. Ahora puedes continuar con tu solicitud de crédito.',
    NIP_BUREAU_MESSAGE: 'Estimado $name, ingresa nuevamente el código de validación de identidad que te enviamos anteriormente.',
    ANNUAL: {
        id: 'ANNUAL',
        value: 'Anual'
    },
    MULTI_YEAR: {
        id: 'MULTI_YEAR',
        value: 'Multianual'
    },
    DOMICILE_ADDRESS: 'Dirección',
    DOMICILE_EXTERNAL_NUMBER: 'Nro. Ext',
    DOMICILE_INTERNAL_NUMBER: 'Nro. Int',
    DOMICILE_POSTAL_CODE: 'Código Postal',
    DOMICILE_STATE: 'Estado',
    DOMICILE_CITY: 'Ciudad',
    DOMICILE_MUNICIPALITY: 'Delegación o Municipio',
    DOMICILE_COLONY: 'Colonia',
    HOLDING_RESIDENCE_TITLE_TYPE: 'Tipo de Vivienda',
    DOMICILE_RESIDENCE_YEARS: 'Años de Residencia',
    DOMICILE_PHONE: 'Teléfono con clave lada',
    DOMICILE_HOUSE_TYPE: 'Tipo de domicilio',
    EMPLOYMENT_VALIDATE_INCOMES: '¿Puede Comprobar sus Ingresos?',
    EMPLOYMENT_TYPES: 'Situación laboral',
    EMPLOYMENT_COMPANY_NAME: 'Empresa donde Labora',
    EMPLOYMENT_POSITION: 'Cargo',
    EMPLOYMENT_START_DATE: 'Inicio de Actividad Laboral',
    EMPLOYMENT_ADDRESS: 'Dirección',
    EMPLOYMENT_EXTERNAL_NUMBER: 'Nro. Ext',
    EMPLOYMENT_INTERNAL_NUMBER: 'Nro. Int',
    EMPLOYMENT_POSTAL_CODE: 'Código Postal',
    EMPLOYMENT_STATE: 'Estado',
    EMPLOYMENT_CITY: 'Ciudad',
    EMPLOYMENT_MUNICIPALITY: 'Delegación o Municipio',
    EMPLOYMENT_COLONY: 'Colonia',
    EMPLOYMENT_HOUSING_TYPE: 'Tipo de Vivienda',
    EMPLOYMENT_MONTHLY_INCOME: 'Ingreso Mensual',
    EMPLOYMENT_PHONE: 'Teléfono de empleo',
    EMPLOYMENT_PHONE_EXT: 'Extensión',
    EMPLOYMENT_TURN: 'Giro empleo',
    EMPLOYMENT_STREET_BETWEEN: 'Entre que calles',
    EMPLOYMENT_DOCUMENT_TYPE: 'Tipo de Comprobante de Ingresos',
    EMPLOYMENT_BUSINESS_TYPE: 'Tipo de Establecimiento',
    EQUIFAX_AUTH: ' garantizo que ésta rúbrica digital corresponde con el registrado en el INE / IFE, y podrá ser utilizada para los fines de esta solicitud de crédito.',
    FINGER_SIGN: 'Utiliza tu dedo para firmar en esta zona',
    COVERAGE: 'Coberturas',
    ACCEPT_TERMS: 'El solicitante acepta los términos y condiciones para la consulta de buró de crédito',
    SUMMARY: 'Resumen',
    SUMMARY_DESIRED_VEHCILE: 'Solicitud de crédito para un ',
    SUMMARY_MONTHLY_INCOME: 'MENSUALIDAD ESTIMADA',
    SUMMARY_DETAIL_COMMISSION: 'Comisión de apertura (3%)',
    SUMMARY_MONTHLY_PAYMENT: 'Mensualidad*',
    SUMMARY_MONTHLY_INSURANCE: 'Seguro estimado',
    SUMMARY_NOTE_MONTHLY_PAYMENT: '*La mensualidad puede cambiar dependiendo del perfil del cliente, ubicación y modelo del vehículo a financiar.',
    SUMMARY_NOTE_TRACKING_DEVICE: 'Incluye: seguros, dispositivo de rastreo y gastos varios.',
    STATE: 'Estado',
    STATE_ALL: 'Todos los estados',
    STATE_FILTER_PLACEHOLDER: 'Estado de residencia del solicitante',
    MONTHLY_QUOTA: 'mensualidad',
    EMPLOYMENT_CHECK_MENSUAL_INCOME: '¿El solicitante puede comprobar sus ingresos?',
    CREDIT_HISTORY: 'Historial de crédito',
    CREDIT_HISTORY_SELECT_TEXT: 'Selecciona las respuestas que se ajustan a tu historial crediticio.',
    CREDIT_HISTORY_CHECK_VEHICULAR_CREDIT: '¿Tiene o ha tenido un crédito vehicular?',
    CREDIT_HISTORY_CHECK_MORTGAGE: '¿Tiene o ha tenido un crédito hipotecario?',
    CREDIT_HISTORY_CHECK_CREDIT_CARD: '¿Tiene una tarjeta de crédito vigente?',
    NOTICE_OF_PRIVACY_OPTION: 'He leído y comprendo el aviso de privacidad',
    NOTICE_OF_PRIVACY_AND_BUREAU_OPTION: 'He leído y comprendo el aviso de privacidad y los términos y condiciones para la consulta de buró de crédito',
    RECEIVE_NEWS_PROMOTIONS_OPTION: 'Quiero recibir información sobre novedades y promociones de Motorfy',
    NOTICE_OF_PRIVACY_BTN: 'he leído el aviso',
    BUREAU_AUTHORIZATION: 'Autorización de buró',
    PRIVACY_AND_BUREAU_AUTHORIZATION: 'Aviso de privacidad y Autorización de Buró',
    BUREAU_AUTHORIZATION_TITLE: 'Autorización de consulta',
    ELECTRONIC_MEADIA_AUTHORIZATION: 'Cláusula de medios electrónicos',
    PRIVACY_AUTHORIZATION: 'Aviso de privacidad',
    BUREAU_AUTHORIZATION_OPTION: 'He leído los términos y condiciones para la consulta de buró de crédito',
    BUREAU_AUTHORIZATION_BTN: 'He leído la autorización',
    REFERENCE_1: 'Referencia 1',
    REFERENCE_2: 'Referencia 2',
    REFERENCE_3: 'Referencia 3',
    ACTUAL_HOME: 'Domicilio actual',
    REFERENCES: 'Referencias',
    DOCUMENTS: 'Documentos',
    WORK_INFO: 'Información laboral',
    INSURANCE: 'Seguros',
    INSURANCE_COMPANIES: 'Aseguradoras',
    INSURANCE_IS_LOADING_TEXT: 'Un momento por favor, estamos obteniendo los datos de las aseguradoras…',
    INSURANCE_SELECT_COMPANY_TEXT: 'Selecciona la aseguradora a la que deseas aplicar.',
    INSURANCE_PERIOD_FINANCING_TEXT: 'El valor del seguro es por 1 año a ser financiado en todo el período del crédito',
    FINISHED_TITLE: 'Solicitud finalizada',
    FINISHED_CONGRATULATIONS: 'Felicidades $name, la solicitud de financiamiento para un $vehicle de $price ' +
    'será procesada por nuestros asesores.',
    FINISHED_CONTACT_1: 'Nos comunicaremos contigo al momento de recibir aprobación.',
    FINISHED_CONTACT_2_LONG_TEXT: 'Si tienes cualquier pregunta puedes contactarte al 2226537555.',
    FINISHED_CONTACT_2: 'Si tienes dudas llámanos al 2226537555',
    FINISHED_CONTACT_PHONE_NUMBER: 'Si tienes dudas llámanos al 2226537555.',
    FINISHED_MESSAGE: 'A continuación puedes ver tus datos enviados en la solicitud.',
    GOTO_HOME: 'Ir al inicio',
    TITLE_FILE_UPLOAD: 'Carga de archivos',
    FILE_UPLOAD_DETAIL: 'Agilita el procesamiento de tu solicitud de crédito adjuntando los siguientes documentos en formato JPG, PNG o PDF, cada archivo debe pesar máximo 10Mb.',
    FILE_UPLOAD_IDENTIFICATION: 'Identificación oficial vigente',
    FILE_UPLOAD_BOX_FRONT: 'Subir Ife frente',
    FILE_UPLOAD_BOX_BACK: 'Subir Ife reverso',
    FILE_UPLOAD_FRONT: 'Subir frente',
    FILE_UPLOAD_BACK: 'Subir reverso',
    FILE_UPLOAD_IDENTIFICATION_EXAMPLE: 'Cargar IFE por ambos lados.',
    FILE_UPLOAD_HOME: 'Comprobante de domicilio',
    FILE_UPLOAD_HOME_BOX: 'Subir comprobante',
    FILE_UPLOAD_HOME_EXAMPLE: 'Con antiguedad máxima de 90 días, ej: Luz, agua, teléfono fijo, predial, gas natural, estados de cuenta bancarios y de servicios de televisión de paga o internet.',
    FILE_UPLOAD_OTHER: 'Comprobante de ingresos ',
    FILE_UPLOAD_DRIVER_LICENSE: 'Licencia de conducción',
    FILE_UPLOAD_OTHER_OPTIONAL: '(opcional)',
    FILE_UPLOAD_OTHER_BOX_1: 'Subir recibo último mes',
    FILE_UPLOAD_OTHER_BOX_2: 'Subir recibo mes previo',
    FILE_UPLOAD_OTHER_BOX_3: 'Subir recibo mes anterior',
    FILE_UPLOAD_OTHER_EXAMPLE: 'Recibos de nómina o estados de cuenta con código QR de los últimos 3 meses',
    YEAR: 'Año',
    MONTH: 'Mes',
    DAY: 'Día',
    MESSAGE_TO_USER_HAS_LOGGED: "Hola! ¿En qué te podemos ayudar?",
    MESSAGE_TO_USER_HAS_NOT_LOGGED: "Hola! ¿En qué te podemos ayudar?"
};

const CALCULATOR = {
    TITLE_1: 'Calcula tus cuotas',
    TITLE_2: 'las cuotas ideales',
    INCLUDES: 'INCLUYE',
    INSURANCE: 'Seguro del vehículo',
    TRACKING: 'Dispositivo de rastreo',
    INSPECTION: 'Gastos de inspección',
    COST: 'Costo de avaluo',
    LEGAL: 'Gasto de legalización',
    BRAND_MODEL_YEAR: 'Marca, Modelo y Año',
    BRAND: isUrlFromSeminuevos => isUrlFromSeminuevos ? 'Marca' : 'Seleccione una Marca',
    MODEL: isUrlFromSeminuevos => isUrlFromSeminuevos ? 'Modelo' : 'Seleccione un Modelo',
    YEAR: 'Año',
    VEHICLE_YEAR: isUrlFromSeminuevos => isUrlFromSeminuevos ? 'Año' : 'Seleccione un Año',
    VEHICLE_YEAR_PLACEHOLDER: 'Seleccione el año del vehículo',
    VERSION: 'Seleccione una Versión',
    PRICE: isUrlFromSeminuevos => isUrlFromSeminuevos ? 'Precio' : 'Ingrese el Precio',
    PRICE_PLACEHOLDER: '¿Cuánto cuesta el vehículo?',
    ENTRY: 'Entrada',
    ENTRY_MX: 'Ingrese el Enganche',
    ENTRY_MX_PLACEHOLDER: '¿Cuánto puedes dar de enganche?',
    TERMS: 'Plazo meses',
    QUOTAS: 'Cuotas financiadas mensuales',
    START_LOAN_LONG_TEXT: 'Inicia tu solicitud de crédito',
    START_LOAN: 'Iniciar solicitud',
    AMOUNT_FINANCE: 'Valor a financiar',
    VEHICLE_DATA: 'Datos del vehículo',
    UPDATE: 'Actualizar',
    DONT_WANT_CONTINUE: 'No deseo continuar',
    WANT_CONTINUE: 'Continuar solicitud'
};

const CALCULATOR_MX = {
    YEAR_PLACEHOLDER: '¿Cuál es el año?',
    YEARS: 'Años',
    BRAND_PLACEHOLDER: 'Seleccione una marca',
    BRANDS: 'Todas las marcas',
    MODEL_PLACEHOLDER: 'Seleccione un modelo',
    MODELS: 'Todos los modelos',
    VERSION_PLACEHOLDER: 'Seleccione una versión',
    VERSIONS: 'Todas las versiones',
    ANNUAL_INSURANCE: 'Seguro anual',
    APPROXIMATE_INSURANCE: 'Seguro aproximado',
    ANNUAL_INSURANCE_INCLUDED_MONTHLY_PAYMENT: 'Incluido en la mensualidad',
    FINANCING_CONDITIONS: 'Condiciones del crédito',
    FINANCING_AMOUNT: 'Monto a financiar',
    FINANCING_AMOUNT_DETAIL: 'Precio del vehículo - Enganche',
    FINANCING_AMOUNT_DOWNPAYMENT_INSURANCE_DETAIL: 'Precio del vehículo - Enganche + Seguro aproximado',
    FINANCING_AMOUNT_DOWNPAYMENT_WITHOUT_INSURANCE_DETAIL: 'Precio del vehículo - Enganche',
    VEHICLE_PRICE: 'Precio del vehículo',
    SAVE_CHANGES: 'Guardar cambios',
    FINANCING_AMOUNT_DETAIL_INSURANCE_ANUAL: ' + Seguro anual',
    MONTHLY_PAYMENTS: 'MENSUALIDADES',
    MONTHLY_PAYMENTS_SIMULATOR: 'Cuotas mensuales',
    MONTHLY_PAYMENTS_DETAIL: 'Selecciona el número de mensualidades al que deseas aplicar.',
    MONTHLY_PAYMENTS_DETAIL_SIMULATOR: 'Para saber las cuotas primero ingrese todos los campos',
    COMMISSION_AMOUNT: 'Comisión de apertura 3%',
    SB_COMMISSION_AMOUNT: 'Comisión por apertura 2.5% + IVA',
    COMMISSION_AMOUNT_COMMISSION_FOR_OPENING: 'Comisión por apertura',
    COMMISSION_AMOUNT_DETAIL: '3% del valor del monto a financiar, debe ser pagada a la agencia/lote junto al enganche.',
    COMMISSION_AMOUNT_DETAIL_SIMULATOR: '3% del valor del monto a financiar',
    SB_COMMISSION_AMOUNT_DETAIL_SIMULATOR: 'Del monto a financiar',
    COMMISSION_AMOUNT_DETAIL_SIMULATOR_FINANCING_AMOUNT: '3% + IVA del valor del monto a financiar',
    CASH_PAYMENTS: 'PAGOS DE CONTADO',
    TITLE_DETAIL: 'Agrega los detalles del vehículo que deseas financiar a través de Motorfy'
};

const SUMMARY_MX = {
    CREDIT_CONDITIONS: 'Condiciones del crédito',
    VEHICLE: 'Vehículo',
    PRICE: 'Precio',
    DOWN_PAYMENT: 'Enganche',
    STATE: 'Estado',
    AMOUNT_FINANCE: 'Monto a financiar',
    TERM: 'Plazo',
    APPLICANT_DATA: 'Datos del solicitante',
    MONTHLY_PAYMENTS: 'Mensualidades',
    COMPLETE_NAME: 'Nombres completos',
    BIRTH_DATE: 'Fecha de nacimiento',
    RFC: 'RFC',
    CELL_PHONE: 'Celular',
    ACTUAL_HOME: 'Domicilio actual',
    EMAIL: 'Correo electrónico',
    ADDRESS: 'Dirección',
    NRO_EXT: 'Nro. Ext',
    NRO_INT: 'Nro. Int',
    POSTAL_CODE: 'Código postal',
    CITY: 'Ciudad',
    MUNICIPALITY: 'Delegación o municipio',
    COLONY: 'Colonia',
    PHONE_WITH_LADA: 'Teléfono con clave lada',
    WORK_INFO: 'Información Laboral',
    WORKPLACE: 'Empresa donde labora',
    POSITION: 'Cargo',
    WORKING_SINCE: 'Inicio de actividad laboral',
    PHONE_NUMBER: 'Número de teléfono',
    EXTENSION: 'Extensión',
    MONTHLY_INCOME: 'Ingreso mensual',
    REFERENCES: 'Referencias',
    INSURANCE: 'Seguro',
    INSURANCE_PAYMENT: 'Pago del seguro',
    INSURANCE_CARRIER: 'Aseguradora',
    ANNUAL_INSURANCE: 'Seguro anual',
    INSURANCE_FINANCED: 'Incluido en el financiamiento',
    INSURANCE_CASH: 'De contado',
    SUBTITLE: 'Enviaremos tu solicitud de financiamiento para un $desiredVehicle de $price para su aprobación.'
};

const NOTIFICATIONS = {
    TITLE: 'Avisos',
    TITLE_EMPTY: 'No tienes avisos nuevos',
    NEW_NOTIFICATIONS: 'Tienes nuevos avisos',
    NO_INTERNET: 'Sin conexión a internet, reconectando…',
    CONNECTED: 'Conectado'
};

const PROFILE = {
    SETTINGS: 'Configuración',
    CALL_CONCIERGE: 'Llamar a asesor Motorfy',
    CHANGE_PASSWORD: 'Cambiar contraseña',
    ABOUT: 'Términos y condiciones',
    CLOSE_SESSION: 'Cerrar sesión',
    TITLE_EDIT: 'Editar perfil'
};

const SETTINGS = {
    TITLE: 'Configuración',
    PUSH: 'Recibir notificaciones push',
    EMAIL: 'Recibir notificaciones por email'
};

const CHANGE_PASSWORD = {
    TITLE: 'Cambiar contraseña',
    PASSWORDS_MISMATCH: 'NO COINCIDEN LAS CONTRASEÑAS',
    OLD: 'contraseña actual',
    NEW: 'nueva contraseña',
    CONFIRM_NEW: 'repite la nueva contraseña'
};

const ABOUT = {
    VERSION: 'Versión',
    APP_BY: '· Una aplicación de LatamAutos Inc.',
    TITLE_SENT: 'Sugerencia enviada',
    SUBTITLE_SENT: 'Gracias por tus comentarios, nos ayudan a  mejorar nuestros servicios.',
};
const ERROR = {
    NoAssociatedUserGroupsError: 'Este usuario no tiene grupos asociados',
    InvalidCredentialsError: 'Usuario o contraseña incorrecta',
    LOGIN_DEFAULT: 'Ocurrió un error al iniciar sesión',
    NO_BITUAJ_RESULT_WARNING: 'Al momento no podemos obtener el valor del seguro',
    NO_BITUAJ_RESULT_FOR_THIS_VEHICLE_WARNING: 'No podemos financiar el seguro de este vehículo',
    APPLICANT_HAS_ANOTHER_APPLICATION_ERROR: 'Ya existe una solicitud con este rfc',
    USERNAME_ALREADY_EXIST_ERROR: 'Ya existe la cuenta',
    INVALID_NIP_CODE_ERROR: 'Código Inválido'
};

const COUNTRY_SELECTOR = {
    SELECT_COUNTRY: 'Selecciona tu país'
};

const GROUP_SELECTOR = {
    SELECT_GROUP: 'Selecciona la cuenta'
};

const NAV_BUTTONS = {
    CREDIT: 'CRÉDITOS',
    CALCULATOR: 'CALCULADORA',
    ACCOUNT: 'CUENTA'
};

export {
    GLOBAL,
    LOGIN,
    LOAN_APPLICATION,
    CALCULATOR,
    CALCULATOR_MX,
    NOTIFICATIONS,
    PROFILE,
    SETTINGS,
    CHANGE_PASSWORD,
    ABOUT,
    ERROR,
    NAV_BUTTONS,
    COUNTRY_SELECTOR,
    GROUP_SELECTOR,
    LOAN_APPLICATION_MX,
    SUMMARY_MX
};
